/**
 * Catálogo de ícones do lucide-react, sem repetição.
 *
 * O pacote exporta o mesmo ícone com vários nomes (`Activity`, `LucideActivity`,
 * `SquareActivity`, `ActivitySquare`...), o que fazia a grade de escolha mostrar
 * cada desenho de duas a quatro vezes. Aqui cada componente aparece uma única
 * vez, mas continua encontrável por qualquer um dos nomes na busca.
 */
import * as LucideIcons from "lucide-react";

let _catalog = null;

/** Lista deduplicada: [{ name, Comp, terms }] em ordem alfabética. */
export function getAllIcons() {
  if (_catalog) return _catalog;

  const byComponent = new Map();
  Object.entries(LucideIcons).forEach(([name, Comp]) => {
    const isComponent = typeof Comp === "object" || typeof Comp === "function";
    if (!isComponent || !/^[A-Z]/.test(name)) return;
    if (name === "Icon" || name.endsWith("Icon")) return;
    const list = byComponent.get(Comp) || [];
    list.push(name);
    byComponent.set(Comp, list);
  });

  _catalog = [...byComponent.entries()]
    .map(([Comp, names]) => {
      const clean = names.filter((n) => !n.startsWith("Lucide"));
      const pool = clean.length ? clean : names;
      // nome mostrado: o mais curto, desempate alfabético
      const name = [...pool].sort((a, b) => a.length - b.length || a.localeCompare(b))[0];
      return { name, Comp, terms: names.map((n) => n.toLowerCase()).join(" ") };
    })
    .sort((a, b) => a.name.localeCompare(b.name));

  return _catalog;
}

export function iconCount() {
  return getAllIcons().length;
}

/** Busca por nome ou por qualquer apelido do ícone. */
export function searchIcons(query) {
  const all = getAllIcons();
  const q = (query || "").trim().toLowerCase();
  if (!q) return all;
  return all.filter((i) => i.terms.includes(q));
}

/** Componente do ícone a partir do nome (aceita qualquer apelido). */
export function lucideByName(name) {
  return name ? LucideIcons[name] || null : null;
}
